import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import useSEO from "@/lib/useSEO";
import { Building2, ArrowUpRight } from "lucide-react";

export default function Projeler() {
  useSEO({
    title: "Projeler",
    description: "YK İnşaat'ın tamamladığı konut, villa ve ticari yapı projeleri.",
    path: "/projeler",
  });
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("Tümü");

  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)).catch(() => {}); }, []);

  const categories = useMemo(() => {
    const set = new Set(projects.map((p) => p.category).filter(Boolean));
    return ["Tümü", ...set];
  }, [projects]);

  const filtered = filter === "Tümü" ? projects : projects.filter((p) => p.category === filter);
  const getImg = (p) => (p?.startsWith("http") ? p : fileUrl(p));

  return (
    <div className="min-h-screen bg-[#0A0E1A]" data-testid="projeler-page">
      <section className="py-24 lg:py-32 border-b border-[#1F2937]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="section-label mb-6">Projeler</div>
          <h1 className="font-heading text-4xl lg:text-6xl text-white tracking-[0.05em] leading-tight max-w-3xl">
            İmzamızı Taşıyan<br />
            <span className="text-[#C9A961]">Tamamlanan Projeler</span>
          </h1>

          {categories.length > 1 && (
            <div className="mt-12 flex flex-wrap gap-3">
              {categories.map((c) => (
                <button
                  key={c}
                  onClick={() => setFilter(c)}
                  data-testid={`filter-${c}`}
                  className={`px-5 py-2 text-xs uppercase tracking-[0.2em] border transition-colors ${
                    filter === c
                      ? "bg-[#C9A961] text-[#0A0E1A] border-[#C9A961]"
                      : "border-[#1F2937] text-white/70 hover:border-[#C9A961] hover:text-[#C9A961]"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          {filtered.length === 0 ? (
            <div className="py-24 text-center border border-dashed border-[#1F2937]">
              <Building2 className="w-12 h-12 text-[#1F2937] mx-auto mb-4" />
              <div className="text-white/50">Henüz proje eklenmedi.</div>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((p) => (
                <Link key={p.id} to={`/projeler/${p.id}`} className="group yk-card overflow-hidden relative" data-testid={`project-card-${p.id}`}>
                  <div className="aspect-[4/5] overflow-hidden bg-[#050812]">
                    {p.images?.[0] ? (
                      <img src={getImg(p.images[0])} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-[#1F2937]">
                        <Building2 className="w-16 h-16" />
                      </div>
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E1A] via-[#0A0E1A]/20 to-transparent"></div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="text-[#C9A961] text-[10px] uppercase tracking-[0.3em] mb-2">{p.category}{p.year ? ` • ${p.year}` : ""}</div>
                    <div className="font-heading text-white text-xl tracking-wider mb-2 group-hover:text-[#C9A961] transition-colors">{p.title}</div>
                    <div className="text-white/60 text-sm">{p.location}</div>
                    <div className="mt-4 inline-flex items-center gap-2 text-[#C9A961] text-xs uppercase tracking-widest">
                      İncele <ArrowUpRight className="w-3.5 h-3.5" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
